var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.696 8.66699H4.94595C3.98083 8.66699 3.19595 9.41449 3.19595 10.3337V18.667C3.19595 19.5862 3.98083 20.3337 4.94595 20.3337H13.696C14.6611 20.3337 15.446 19.5862 15.446 18.667V10.3337C15.446 9.41449 14.6611 8.66699 13.696 8.66699Z",
    fill: "#AFAFB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.946 3.66699H10.196C9.73182 3.66699 9.28671 3.84259 8.95852 4.15515C8.63033 4.46771 8.44595 4.89163 8.44595 5.33366V7.00033H15.446C15.9101 7.00033 16.3552 7.17592 16.6834 7.48848C17.0116 7.80104 17.196 8.22497 17.196 8.66699V15.3337H18.946C19.4101 15.3337 19.8552 15.1581 20.1834 14.8455C20.5116 14.5329 20.696 14.109 20.696 13.667V5.33366C20.696 4.89163 20.5116 4.46771 20.1834 4.15515C19.8552 3.84259 19.4101 3.66699 18.946 3.66699Z",
    fill: "#AFAFB0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.bd49e906c0f896e561777acd7dd218f0.svg";
export { ForwardRef as ReactComponent };